import { render, staticRenderFns } from "./BroadcastEdit.vue?vue&type=template&id=3292258f&scoped=true"
import script from "./BroadcastEdit.vue?vue&type=script&lang=js"
export * from "./BroadcastEdit.vue?vue&type=script&lang=js"
import style0 from "./BroadcastEdit.vue?vue&type=style&index=0&id=3292258f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3292258f",
  null
  
)

export default component.exports